interface ReferenceElement {
    selector?: string, target?: HTMLElement | undefined;
}

interface AnchorConfig {
    anchorItemClass: string;
}

export default class AnchorButtons {
    wrapperButtons: ReferenceElement;
    config: AnchorConfig;
    sectionIdList: Array<string> = [];
    buttonlist: NodeListOf<HTMLAnchorElement>;

    constructor(selectorContainer: string, config: AnchorConfig) {
        this.wrapperButtons = { selector: selectorContainer, target: document.querySelector(selectorContainer) as HTMLElement };
        this.config = config
        this.init()
    }

    init(): void {
        let { anchorItemClass } = this.config;
        let { target } = this.wrapperButtons;

        this.buttonlist = target?.querySelectorAll(`.${anchorItemClass}`) as NodeListOf<HTMLAnchorElement>

        this.buttonlist?.forEach(button => {
            let sectionId = button.getAttribute("href")?.replace('#', '')
            if (sectionId) {
                button.setAttribute("data-section", sectionId)
                this.sectionIdList.push(sectionId)
            }
        })

        this.observerSection()
    }

    observerSection(): void {
        let { anchorItemClass } = this.config;

        let config = {
            threshold: 0.5
        }

        let observer = new IntersectionObserver((entries: IntersectionObserverEntry[], observer: IntersectionObserver) => {
            entries.forEach((entry: IntersectionObserverEntry) => {
                if (entry.isIntersecting) {
                    let oldSection = Array.from(this.buttonlist).find(item => item.classList.contains(`${anchorItemClass}--active`))
                    oldSection?.classList.remove(`${anchorItemClass}--active`)

                    let nwSection = Array.from(this.buttonlist).find(item => item.dataset.section == entry.target.id)
                    nwSection?.classList.add(`${anchorItemClass}--active`)
                }
            })
        }, config)

        this.sectionIdList?.forEach(item => {
            let targetSection = document.querySelector(`#${item}`)
            targetSection && observer.observe(targetSection)
        })
    }
}